import { middlewareFetch } from '~/composables/useMiddlewareFetch'

export default defineNuxtRouteMiddleware(async (to, from) => {
    const order = useOrder()
    const { get } = useOFetchCustom(`order-externals/${to.params.order}/show`)

    return middlewareFetch(
        (onSuccess, onError) => {
            get(undefined, {
                onSuccess: (response: any) => onSuccess(response.data),
                onError,
            })
        },
        order,
        {
            redirectOnError: (error) => error.status === 403 ? '/store' : undefined
        }
    )
})
